/* ====================================================================
   COLETTE DEMAY · Shopify Theme — theme.js
   --------------------------------------------------------------------
   Retirés de ce fichier (maquette statique) :
     · le faux panier Store + sa table de prix en dur (localStorage)
     · renderSearchResults et ses liens vers l'ancien site statique
     · le tiroir panier factice et ses boutons d'ajout de maquette
     · la fausse confirmation newsletter
     · setLang/getLang qui forçait la langue du document
   Le panier réel est piloté par le snippet injecté en fin de page,
   la recherche par routes.search_url, la newsletter par le formulaire
   client Shopify, et la langue par localization.available_languages.
   ==================================================================== */
(function () {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============== MONEY FORMAT ============== */
  function money(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  window.cdMoney = money;

  /* ============== HEADER scroll state ============== */
  const header = document.querySelector('.site-header');
  if (header) {
    const upd = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    upd();
    window.addEventListener('scroll', upd, { passive: true });
  }

  /* ============== REVEAL ============== */
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => revealObs.observe(el));

  /* ============== RECETTE PARALLAX ============== */
  if (!reduce) {
    document.querySelectorAll('.recette').forEach(section => {
      const img = section.querySelector('.recette-image img');
      if (!img) return;
      let raf = null;
      const update = () => {
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight;
        const total = rect.height + vh;
        const passed = vh - rect.top;
        const p = Math.max(0, Math.min(1, passed / total));
        const x = -6 + p * 12;
        img.style.transform = `translateX(${x}%) scale(1.08)`;
        raf = null;
      };
      window.addEventListener('scroll', () => {
        if (raf == null) raf = requestAnimationFrame(update);
      }, { passive: true });
      update();
    });

    // Coffret images on shop cards subtle parallax
    document.querySelectorAll('.pcard-image img').forEach(img => {
      // tiny mouse-driven tilt
      const card = img.closest('.pcard');
      if (!card) return;
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = `scale(1.06) translate(${x * -8}px, ${y * -6}px)`;
      });
      card.addEventListener('mouseleave', () => { img.style.transform = ''; });
    });
  }

  /* ============== VIDEO playback ============== */
  document.querySelectorAll('video[data-slow]').forEach(v => {
    v.playbackRate = parseFloat(v.dataset.slow) || 0.5;
    v.play().catch(() => {});
  });

  /* ============== SEARCH OVERLAY ==============
     Ouverture / fermeture uniquement. Le formulaire pointe sur
     routes.search_url : la recherche est faite par Shopify. */
  const sBtn = document.querySelector('[data-search-open]');
  const overlay = document.querySelector('.search-overlay');
  const sClose = overlay && overlay.querySelector('.search-close');
  const sInput = overlay && overlay.querySelector('.search-input');

  function openSearch() {
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => sInput && sInput.focus(), 200);
  }
  function closeSearch() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  sBtn && sBtn.addEventListener('click', openSearch);
  sClose && sClose.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  // Suggest tags : remplissent le champ puis lancent la vraie recherche
  document.querySelectorAll('.search-suggest .tag').forEach(t => {
    t.addEventListener('click', () => {
      if (!sInput) return;
      sInput.value = t.textContent.trim();
      const form = sInput.form || (overlay && overlay.querySelector('form'));
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      } else {
        sInput.focus();
      }
    });
  });

  /* ============== FONDATEUR word-by-word ============== */
  const fondateurSection = document.querySelector('.fondateur');
  const typeTarget = document.getElementById('fondateurType');
  if (fondateurSection && typeTarget) {
    const part1 = '« J’ai voulu construire une maison qui refuse. Refuse l’arôme artificiel, refuse le sucre qui couvre, refuse la facilité de la ganache. ';
    const part2 = 'En enlevant tout ce qui encombre, on retrouve l’essentiel : la courbe du praliné, l’éclat de l’ingrédient invité. C’est ce retour à la matière que je voulais offrir.';
    const tail = ' »';

    const buildWords = (text, em) => {
      const frag = document.createDocumentFragment();
      const words = text.split(/(\s+)/);
      words.forEach(w => {
        if (/^\s+$/.test(w)) frag.appendChild(document.createTextNode(w));
        else if (w.length) {
          const s = document.createElement('span');
          s.className = 'fw' + (em ? ' em' : '');
          s.textContent = w;
          frag.appendChild(s);
        }
      });
      return frag;
    };
    typeTarget.innerHTML = '';
    typeTarget.appendChild(buildWords(part1, false));
    const emWrap = document.createElement('em');
    emWrap.appendChild(buildWords(part2, true));
    typeTarget.appendChild(emWrap);
    typeTarget.appendChild(document.createTextNode(tail));

    const words = typeTarget.querySelectorAll('.fw');
    if (reduce) {
      words.forEach(w => w.classList.add('in'));
    } else {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);
          words.forEach((w, i) => {
            w.style.transitionDelay = (i * 0.08) + 's';
            requestAnimationFrame(() => w.classList.add('in'));
          });
        });
      }, { threshold: 0.3 });
      obs.observe(fondateurSection);
    }
  }

})();
